// // import React from "react";
// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";
// import { formatCurrency } from "./utils";

// export const printOrderList = (orders, list_title) => {
//     const doc = new jsPDF({ unit: "mm", format: "a4", });

//     // Set margins (0.5 inch = 12.7 mm)
//     const margin = 12.7;
//     let startY = margin;

//     doc.setFont("helvetica", "bold");
//     doc.setFontSize(12);
//     doc.text(list_title, margin, margin);

//     const grouped = orders.reduce((acc, order) => {
//         const key = order.ItemName;
//         if (!acc[key]) acc[key] = [];
//         acc[key].push(order);
//         return acc;
//     }, {});

//     const groupedArray = Object.keys(grouped).map(itemName => ({
//         itemName,
//         orders: grouped[itemName]
//     }));

//     groupedArray.forEach(group => {
//         const title = group.itemName;
//         const tableRows = group.orders.map(order => [
//             order.CustomerName,
//             order.ItemQty + "x",
//             formatCurrency(order.Price),
//             formatCurrency(order.PaidAmount) === "0.00" ? "No DP" : formatCurrency(order.PaidAmount),
//             order.Cargo === "AC" ? "Air Cargo" : "Sea Cargo"
//         ]);

//         doc.setFont("helvetica", "bold");
//         doc.setFontSize(10);
//         doc.text(title, margin, startY + 8);

//         autoTable(doc, {
//             startY: startY + 10,
//             head: [["Customer Name", "Qty", "Price", "Payment", "Cargo"]],
//             body: tableRows,
//             margin: { top: margin, left: margin, right: margin },
//             tableWidth: 'auto',
//             styles: {
//                 fontSize: 9,
//                 lineWidth: 0.1,
//                 lineColor: [0, 0, 0],
//             },
//             headStyles: {
//                 fillColor: [141, 216, 115],
//                 textColor: [0, 0, 0],
//                 halign: "left",
//                 lineWidth: 0.1,
//                 lineColor: [0, 0, 0],
//                 fontStyle: "bold",
//                 cellPadding: 1
//             },
//             bodyStyles: {
//                 halign: "left",
//                 lineWidth: 0.1,
//                 lineColor: [0, 0, 0],
//                 cellPadding: 1
//             },
//             columnStyles: {
//                 0: { cellWidth: "auto", halign: "left" }, // Customer
//                 1: { cellWidth: 20, halign: "center" },   // Qty
//                 2: { cellWidth: 25, halign: "center" },   // Price (centered)
//                 3: { cellWidth: 29, halign: "center" },   // Payment
//                 4: { cellWidth: 29, halign: "center" }    // Cargo
//             },
//             didParseCell: (data) => {
//                 if (data.section === "head" && [1, 2, 3, 4].includes(data.column.index)) {
//                     data.cell.styles.halign = "center";
//                 }
//             },
//             theme: "grid"
//         });
//         startY = doc.lastAutoTable.finalY;
//     });

//     const pdfBlob = doc.output("blob");
//     const pdfUrl = URL.createObjectURL(pdfBlob);

//     window.open(pdfUrl, "_blank");
// }






import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { formatCurrency } from "../components/utils";

// ─── Page constants (A4, 0.5" margins) ────────────────────────────────────────

const PAGE = {
    width: 210,
    height: 297,
    margin: 12.7,
};

const CONTENT_WIDTH = PAGE.width - PAGE.margin * 2;

export const printListedOrders = (orders, list_title) => {
    const doc = new jsPDF({ unit: "mm", format: "a4" });

    const generatedDate = new Date().toLocaleDateString("en-US", {
        year: "numeric", month: "long", day: "numeric",
    });

    // ─── Group orders by item name ────────────────────────────────────────────
    const grouped = orders.reduce((acc, order) => {
        const key = order.ItemName;
        if (!acc[key]) acc[key] = [];
        acc[key].push(order);
        return acc;
    }, {});

    const groupedArray = Object.keys(grouped).map((itemName) => ({
        itemName,
        orders: grouped[itemName],
    }));

    const totalOrders = orders.length;

    // ─── Document header (drawn once per page via didDrawPage) ───────────────

    const drawHeader = () => {
        // Title
        doc.setFont("helvetica", "bold");
        doc.setFontSize(15);
        doc.setTextColor(20, 20, 20);
        doc.text(list_title, PAGE.margin, PAGE.margin + 2);

        // Subtitle: generated date + total count
        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
        doc.setTextColor(110, 110, 110);
        doc.text(
            `Generated on ${generatedDate}  ·  ${totalOrders} order${totalOrders !== 1 ? "s" : ""} total`,
            PAGE.margin,
            PAGE.margin + 8
        );

        // Divider line under header
        doc.setDrawColor(210, 210, 210);
        doc.setLineWidth(0.3);
        doc.line(PAGE.margin, PAGE.margin + 12, PAGE.width - PAGE.margin, PAGE.margin + 12);
    };

    const drawFooter = (pageNumber, pageCount) => {
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8);
        doc.setTextColor(150, 150, 150);

        // Left: small generated note
        doc.text(
            list_title,
            PAGE.margin,
            PAGE.height - PAGE.margin + 6
        );

        // Right: page numbers
        doc.text(
            `Page ${pageNumber} of ${pageCount}`,
            PAGE.width - PAGE.margin,
            PAGE.height - PAGE.margin + 6,
            { align: "right" }
        );

        // Top border line above footer
        doc.setDrawColor(225, 225, 225);
        doc.setLineWidth(0.2);
        doc.line(
            PAGE.margin, PAGE.height - PAGE.margin + 2,
            PAGE.width - PAGE.margin, PAGE.height - PAGE.margin + 2
        );
    };

    // ─── Initial header on page 1 ──────────────────────────────────────────────
    drawHeader();
    let startY = PAGE.margin + 18;

    // ─── Render each group as its own labeled table ───────────────────────────

    groupedArray.forEach((group, groupIndex) => {
        const title = group.itemName;
        const groupCount = group.orders.length;

        const tableRows = group.orders.map((order) => [
            order.CustomerName,
            order.ItemQty + "x",
            formatCurrency(order.Price),
            formatCurrency(order.PaidAmount) === "0.00" ? "No DP" : formatCurrency(order.PaidAmount),
            order.Cargo === "AC" ? "Air Cargo" : "Sea Cargo",
        ]);

        // Page-break check: if section title won't fit, force new page first
        const estimatedHeight = 14 + groupCount * 7;
        if (startY + estimatedHeight > PAGE.height - PAGE.margin - 10 && groupIndex !== 0) {
            doc.addPage();
            drawHeader();
            startY = PAGE.margin + 18;
        }

        // ── Section label row (item name + count pill) ──
        doc.setFillColor(245, 247, 245);
        doc.setDrawColor(220, 224, 220);
        doc.setLineWidth(0.2);
        doc.roundedRect(PAGE.margin, startY, CONTENT_WIDTH, 7, 1, 1, "FD");

        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.setTextColor(30, 30, 30);
        doc.text(title, PAGE.margin + 3, startY + 4.8);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(8.5);
        doc.setTextColor(100, 100, 100);
        doc.text(
            `${groupCount} order${groupCount !== 1 ? "s" : ""}`,
            PAGE.width - PAGE.margin - 3,
            startY + 4.8,
            { align: "right" }
        );

        // ── Table ──
        autoTable(doc, {
            startY: startY + 9,
            head: [["Customer Name", "Qty", "Price", "Payment", "Cargo"]],
            body: tableRows,
            margin: { top: PAGE.margin + 18, left: PAGE.margin, right: PAGE.margin, bottom: PAGE.margin + 8 },
            tableWidth: CONTENT_WIDTH,
            styles: {
                font: "helvetica",
                fontSize: 9,
                lineWidth: 0.1,
                lineColor: [225, 225, 225],
                cellPadding: { top: 2, bottom: 2, left: 2.5, right: 2.5 },
                textColor: [40, 40, 40],
            },
            headStyles: {
                fillColor: [28, 37, 54],
                textColor: [255, 255, 255],
                fontStyle: "bold",
                fontSize: 8.5,
                halign: "left",
                lineWidth: 0,
                cellPadding: { top: 2.5, bottom: 2.5, left: 2.5, right: 2.5 },
            },
            bodyStyles: {
                halign: "left",
                lineColor: [230, 230, 230],
            },
            alternateRowStyles: {
                fillColor: [250, 251, 252],
            },
            columnStyles: {
                0: { cellWidth: "auto", halign: "left" }, // Customer
                1: { cellWidth: 16, halign: "center" }, // Qty
                2: { cellWidth: 26, halign: "right" }, // Price
                3: { cellWidth: 30, halign: "right" }, // Payment
                4: { cellWidth: 26, halign: "center" }, // Cargo
            },
            didParseCell: (data) => {
                if (data.section === "head" && [1, 2, 3, 4].includes(data.column.index)) {
                    data.cell.styles.halign = data.column.index === 1 || data.column.index === 4
                        ? "center"
                        : "right";
                }
            },
            theme: "grid",
            didDrawPage: () => {
                // Re-draw header on every new page created mid-table
                drawHeader();
            },
        });

        // Space after table before next group
        startY = doc.lastAutoTable.finalY + 8;
    });

    // ─── Apply footer with page numbers to every page ─────────────────────────
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        drawFooter(i, pageCount);
    }

    // ─── Output ────────────────────────────────────────────────────────────────
    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl, "_blank");
};
